export default "__VITE_ASSET__e4e33c3d__"